export default __webpack_public_path__ + "static/media/_MakeCrop.ccbffe63.gif";